import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  FireLinkGroupSuccess,
  LinkGroupActionTypes,
  LinkGroupOnServerCreated,
  LinkGroupOnServerDeleted,
  LinkGroupOnServerUpdated,
  LinkGroupsLoaded,
  LinkGroupsPageLoaded,
  LinkGroupsPageRequested,
  LinkGroupsPageToggleLoading,
  LinkGroupsRequested,
  ThrowLinkGroupError,
} from '../_actions/link-group.actions';
import { Router } from '@angular/router';
import { LinkGroupService } from '../_services/link-groups.service';
import { QueryParamsModel } from '../../_base/crud';
import { CategoryService } from '../../lists';

@Injectable()
export class LinkGroupEffects {
  teamIds = [];
  teams = [];
  @Effect()
  loadLinkGroupsPage$ = this.actions$.pipe(
    ofType<LinkGroupsPageRequested>(LinkGroupActionTypes.LinkGroupsPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(new LinkGroupsPageToggleLoading({ isLoading: true }));
      const requestToServer = this.linkGroup.findLinkGroups(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]);
    }),
    map((response) => {
      const result = response[0];
      const lastQuery: QueryParamsModel = response[1];
      return new LinkGroupsPageLoaded({
        linkGroups: result.data,
        totalCount: result.count,
        page: lastQuery,
      });
    }),
  );

  @Effect()
  loadLinkGroups$ = this.actions$.pipe(
    ofType<LinkGroupsRequested>(LinkGroupActionTypes.LinkGroupsRequested),
    mergeMap(() => {
      return this.linkGroup.loadLinkGroups().pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.error) {
            return of({ type: 'NO_ACTION' });
          } else {
            return new LinkGroupsLoaded({ linkGroups: res.data });
          }
        }),
      );
    }),
  );

  @Effect()
  deleteLinkGroup$ = this.actions$.pipe(
    ofType<LinkGroupOnServerDeleted>(LinkGroupActionTypes.LinkGroupOnServerDeleted),
    mergeMap(({ payload }) => {
      return this.linkGroup.deleteLinkGroup(payload.id).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.error) {
            return new ThrowLinkGroupError({ error: res.error });
          } else {
            this.store.dispatch(new LinkGroupsRequested());
            return new FireLinkGroupSuccess({
              action_type: LinkGroupActionTypes.LinkGroupOnServerDeleted,
            });
          }
        }),
      );
    }),
  );

  @Effect()
  updateLinkGroup$ = this.actions$.pipe(
    ofType<LinkGroupOnServerUpdated>(LinkGroupActionTypes.LinkGroupOnServerUpdated),
    mergeMap(({ payload }) => {
      return this.linkGroup.updateLinkGroup(payload.linkGroup).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.error) {
            return new ThrowLinkGroupError({ error: res.error });
          } else {
            this.store.dispatch(new LinkGroupsRequested());
            return new FireLinkGroupSuccess({
              action_type: LinkGroupActionTypes.LinkGroupOnServerUpdated,
            });
          }
        }),
      );
    }),
  );

  @Effect()
  createLinkGroup$ = this.actions$.pipe(
    ofType<LinkGroupOnServerCreated>(LinkGroupActionTypes.LinkGroupOnServerCreated),
    mergeMap(({ payload }) => {
      return this.linkGroup.createLinkGroup(payload).pipe(
        catchError((error) => {
          return of(error);
        }),
        map((res) => {
          if (res && res.error) {
            return new ThrowLinkGroupError({ error: res.error });
          } else {
            this.store.dispatch(new LinkGroupsRequested());
            return new FireLinkGroupSuccess({
              action_type: LinkGroupActionTypes.LinkGroupOnServerCreated,
            });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private linkGroup: LinkGroupService,
    private store: Store<AppState>,
    private router: Router,
    private categoryService: CategoryService,
  ) {}
}
